import { IconProps } from '@/components/Icon/types';

function ExternalLink(props: IconProps) {
  return (
    <svg
      {...props}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6272 2.7L9.1636 9.1636C8.81213 9.51508 8.81213 10.0849 9.1636 10.4364C9.51508 10.7879 10.0849 10.7879 10.4364 10.4364L16.9001 3.97273V7.61818C16.9001 8.11524 17.303 8.51818 17.8001 8.51818C18.2971 8.51818 18.7001 8.11524 18.7001 7.61818V1.8C18.7001 1.6489 18.6628 1.50649 18.597 1.38146C18.5936 1.37493 18.5901 1.36843 18.5865 1.36197C18.5686 1.32992 18.5486 1.29874 18.5265 1.26862C18.5219 1.26229 18.5172 1.256 18.5123 1.24977C18.4695 1.19445 18.4204 1.14425 18.3661 1.10025C18.3072 1.05248 18.2437 1.01326 18.1772 0.982587C18.0625 0.929576 17.9347 0.9 17.8001 0.9C17.8 0.9 17.7999 0.9 17.7998 0.9H11.9819C11.4848 0.9 11.0819 1.30294 11.0819 1.8C11.0819 2.29706 11.4848 2.7 11.9819 2.7H15.6272ZM0.9 4.70906C0.9 4.212 1.30294 3.80906 1.8 3.80906H7.98182C8.47888 3.80906 8.88182 4.212 8.88182 4.70906C8.88182 5.20611 8.47888 5.60906 7.98182 5.60906H2.7V16.9H13.9909V11.6181C13.9909 11.1211 14.3939 10.7181 14.8909 10.7181C15.388 10.7181 15.7909 11.1211 15.7909 11.6181V17.8C15.7909 18.297 15.388 18.7 14.8909 18.7H1.8C1.30294 18.7 0.9 18.297 0.9 17.8V4.70906Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ExternalLink;
